import { TICKET_STATUS } from '@/pages/Tickets/Tickets.constants';

import type { StatusTypes } from './StatusChip.types';

export default function getStatusColor(status: StatusTypes) {
  switch (status) {
    case TICKET_STATUS.OPEN:
      return 'warning';
    case TICKET_STATUS.DRAFT:
      return 'secondary';
    case TICKET_STATUS.ACKNOWLEDGED:
      return 'info';
    case TICKET_STATUS.NEEDS_REVIEW:
      return 'error';
    case TICKET_STATUS.COMPLETED:
      return 'success';
    case TICKET_STATUS.REMEDIATED:
      return 'info';
    case TICKET_STATUS.AUTO_CLOSED:
      return 'success';
    case 'Active':
      return 'success';
    case 'Unknown':
      return 'warning';
    case 'Error':
      return 'error';
    case 'Disabled':
      return 'secondary';
    default:
      return 'secondary';
  }
}
